// extracted by mini-css-extract-plugin
export default {"globe-icon":"globe-icon__LGqUI"};